import { Component } from '@angular/core';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.css'],
    standalone: false
})
export class SupportComponent {

  constructor() { }

}
